// «Ultime sessioni»: le ultime chiuse, con l'esito; le altre stanno in Archivio.
import { Link } from 'react-router-dom';
import { RelativeTime } from '../../../components/RelativeTime';
import { StatusPill } from '../../../components/StatusPill';
import type { Session } from '../../../types';
import { Widget } from '../Widget';

export function Recent({ sessions }: { sessions: Session[] }) {
  return (
    <Widget
      title="Ultime sessioni"
      icon="history"
      detailsTo="/archivio"
      detailsLabel="Archivio"
      tint="lilac"
    >
      {sessions.length === 0 ? (
        <div className="t-caption faint">Ancora nessuna sessione chiusa.</div>
      ) : (
        <div style={{ display: 'grid', gap: 8 }}>
          {sessions.slice(0, 5).map((s) => (
            <Link key={s.id} to={`/s/${s.id}`} className="dash-session">
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className="t-strong trunc" style={{ display: 'block' }}>
                  {s.title}
                </span>
                <span className="t-caption dim trunc" style={{ display: 'block' }}>
                  {s.projectName ?? 'senza progetto'} · <RelativeTime at={s.updatedAt} />
                </span>
              </span>
              <StatusPill state={s.state} size="sm" />
            </Link>
          ))}
        </div>
      )}
    </Widget>
  );
}
